<template>

  <div>


    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseLinkId" :primary-key="form.enterpriseLinkId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Links" sortable
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onItemReadDefault"
                 @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.enterpriseLinkId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <t-input cols="4"
                       v-model="form.title"
                       label="Título"
                       required/>

              <t-input cols="4" v-model="form.link" placeholder="https://..."
                       label="Link" required  />

              <t-input cols="4" v-model="form.note" label="Obs."/>

            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>

      <template #item(link)="{item}">
        <b-link target="_blank" :href="item.link">{{item.link}}</b-link>
      </template>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'EnterpriseLink',
  data() {
    return {
      path: "place/enterprise-link", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseLinkId", keyDelete: "enterpriseLinkId"},
        {key: "title", label: "Título", cols: "2"},
        {key: "link", label: "Link", cols: "4"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseLinkId: 0,
        link: "",
        title: "",
        note: "",
        status: 1,

      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------

      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseLinkId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
